import * as React from "react";
import FieldWrapper, {GenericCheckbox, GenericDropdown,} from "../FieldWrapper";
import {SettingEnum, SettingPrefixEnum} from "../settingEnum";
import {LabelEnum} from "../../LabelEnum";
import withFormWrapper from "@Elements/Form/formWrapper";
import InformationIcon from "../../../../Elements/Icon/Icons/InformationIcon";
import { TIME_OFFSET, status } from "@Elements/Form/utils";
import { DeviceSettings } from "../types";
import { SettingDiv } from "../styled";
import { ValueSelector } from "@Safemate/Settings/SoundLight/Components/valueSelector";
import { buttonSensitivityOpts } from "./options";

export const AlarmCallAlert = () => 
  <SettingDiv isChanged>
    <ValueSelector
      title={{id: "deliveryFormat", defaultMessage: "Leveringsformat"}}
      name={SettingEnum.ALARM_CALL_ALERT}
      count={2}
      vertical
      removeArrows
      optionsOverride={[
        "false",
        "true"
      ]}
      label={[
        { id: "smsAlerts", defaultMessage: "Bare SMS" },
        { id: "callAlerts", defaultMessage: "Oppringing og SMS" }
      ]}
    />
  </SettingDiv>

export const ButtonSensitivity = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.ALARM_SETTINGS,
  field: SettingEnum.BUTTON_SENSITIVITY,
  title: "alarmSensitivity",
  dataOptions: {
    options: buttonSensitivityOpts,
    offset: TIME_OFFSET.SECONDS_IN_SECOND
  }
})

export const ButtonBehaviour = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: true,
      label: {id: "disableAlarmButton", defaultMessage: "Alarmknapp"},
    }
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.ALARM_SETTINGS,
  field: SettingEnum.BUTTON_BEHAVIOUR
});

export const SilentAlarm = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: false,
      label: {id: "silentAlarm", defaultMessage: "Lydløs alarm"},
    }
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.ALARM_SETTINGS,
  field: SettingEnum.SILENT_ALARM
});